// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.circular-container-engg {
  position: relative;
  width: 600px;
  height: 600px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
}

.central-wrapper-engg {
  position: absolute;
  width: 180px;
  height: 180px;
  border-radius: 50%;
  border: 3px dotted #ddd;
  display: flex;
  justify-content: center;
  align-items: center;
}

.central-image-engg {
  position: absolute;
  width: 150px;
  height: 150px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.central-image-engg img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.3);
}

.circular-item-engg {
  position: absolute;
  display: flex;
  align-items: center;
  transform-origin: center;
}
.line-engg {
  position: absolute;
  width: 120px !important;
  height: 0.15px !important;
  background: transparent;
  border-top: 2px dashed #000 !important;
  transform-origin: left;
}

.line-1-engg {
  width: 50% !important;
  transform: rotate(-50deg);
  top: 290% !important;
  right: 56% !important;
}
.line-2-engg {
  top: 50%;
  left: -123% !important;
  width: 122% !important;
  transform: rotate(0deg);
}
.line-3-engg {
  top: 0%;
  left: 20%;
  width: 47% !important;
  transform: rotate(230deg);
}
.line-4-engg {
  top: 50%;
  left: 188%;
  width: 87% !important;
  transform: rotate(180deg);
}
.line-5-engg {
  top: 315%;
  left: 128%;
  width: 66% !important;
  transform: rotate(223deg);
}
.line-6-engg {
  top: -10%;
  left: 78%;
  width: 47% !important;
  transform: rotate(320deg);
}
.circular-button-engg {
  display: flex;
  align-items: center;
  background: white;
  border: 2px solid black;
  border-radius: 50px;
  padding: 5px 10px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  gap: 10px;
}
.circular-button-engg img {
  width: 40px;
  height: 40px;
  transition: transform 0.1s ease;
}

.circular-button-engg:hover {
  transform: scale(1.2);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.circular-button-engg:hover img {
  transform: scale(1.1);
}

.circular-button-engg.reverse:hover {
  transform: scale(1.1);
}
.circular-button-engg.reverse {
  flex-direction: row;
}

.circular-button-engg.reverse img {
  margin-right: 0;
  margin-left: 5px;
}

.circular-button-engg:hover {
  background-color: #abe46c;
}

.circular-button-engg.active-button-engg {
  background-color: #abe46c;
  color: black;
  cursor: default;
}

.circular-item-engg img {
  width: 30px;
  height: 30px;
  border-radius: 50%;
}

.circular-item-engg p {
  margin: 0;
  font-size: 14px;
  font-weight: bold;
}

.page-section-engg {
  margin-top: 20px;
  border: 1px solid #ddd;
  border-radius: 8px;
  background-color: #f9f9f9;
  margin-bottom: -50px;
  margin-top: -80px;
}

.page-section-engg h2 {
  font-size: 1.8em;
  margin-bottom: 20px;
}

.page-section-engg p {
  font-size: 1.2em;
  color: #555;
}

@media screen and (max-width: 768px) {
  .circular-container-engg {
    width: 400px;
    height: 400px;
    padding-bottom: 30px;
  }

  .central-image-engg img {
    width: 50%;
    height: 50%;
    border-radius: 50%;
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.3);
  }

  .central-wrapper-engg {
    position: absolute;
    width: 90px;
    height: 90px;
    border-radius: 50%;
    border: 3px dotted #ddd;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .circular-item-engg {
    transform-origin: center;
  }

  .circular-button-engg {
    padding: 4px 4px;
    gap: 3px;
  }

  .circular-item-engg p {
    font-size: 10px;
  }

  .line-engg {
    width: 60px !important;
    height: 0.1px !important;
    border-top: 1px dashed #000 !important;
  }

  .line-1-engg {
    width: 45% !important;
    transform: rotate(-55deg);
    top: 230% !important;
    left: 15% !important;
  }
  .line-2-engg {
    top: 40%;
    left: -32% !important;
    width: 35% !important;
    transform: rotate(0deg);
  }
  .line-3-engg {
    top: -5%;
    left: 40%;
    width: 32% !important;
    transform: rotate(230deg);
  }
  .line-4-engg {
    top: 43%;
    left: 125%;
    width: 25% !important;
    transform: rotate(180deg);
  }
  .line-5-engg {
    top: 230%;
    left: 98%;
    width: 49% !important;
    transform: rotate(230deg);
  }
  .line-6-engg {
    top: -7%;
    left: 70%;
    width: 28% !important;
    transform: rotate(308deg);
  }
  .circular-button-engg:hover img {
    transform: scale(0.9);
  }

  .circular-button-engg.reverse:hover {
    transform: scale(1.1);
  }
  .circular-button-engg:hover {
    transform: scale(1.1);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/CircularDesignEngg/CircularDesignEngg.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,uBAAuB;EACvB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,wBAAwB;AAC1B;AACA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,yBAAyB;EACzB,uBAAuB;EACvB,sCAAsC;EACtC,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,oBAAoB;EACpB,qBAAqB;AACvB;AACA;EACE,QAAQ;EACR,sBAAsB;EACtB,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,OAAO;EACP,SAAS;EACT,qBAAqB;EACrB,yBAAyB;AAC3B;AACA;EACE,QAAQ;EACR,UAAU;EACV,qBAAqB;EACrB,yBAAyB;AAC3B;AACA;EACE,SAAS;EACT,UAAU;EACV,qBAAqB;EACrB,yBAAyB;AAC3B;AACA;EACE,SAAS;EACT,SAAS;EACT,qBAAqB;EACrB,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,sCAAsC;EACtC,SAAS;AACX;AACA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;EACrB,wCAAwC;AAC1C;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;EACzB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE;IACE,YAAY;IACZ,aAAa;IACb,oBAAoB;EACtB;;EAEA;IACE,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,0CAA0C;EAC5C;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;IACvB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,gBAAgB;IAChB,QAAQ;EACV;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,wBAAwB;IACxB,sCAAsC;EACxC;;EAEA;IACE,qBAAqB;IACrB,yBAAyB;IACzB,oBAAoB;IACpB,oBAAoB;EACtB;EACA;IACE,QAAQ;IACR,qBAAqB;IACrB,qBAAqB;IACrB,uBAAuB;EACzB;EACA;IACE,QAAQ;IACR,SAAS;IACT,qBAAqB;IACrB,yBAAyB;EAC3B;EACA;IACE,QAAQ;IACR,UAAU;IACV,qBAAqB;IACrB,yBAAyB;EAC3B;EACA;IACE,SAAS;IACT,SAAS;IACT,qBAAqB;IACrB,yBAAyB;EAC3B;EACA;IACE,QAAQ;IACR,SAAS;IACT,qBAAqB;IACrB,yBAAyB;EAC3B;EACA;IACE,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;AACF","sourcesContent":[".circular-container-engg {\n  position: relative;\n  width: 600px;\n  height: 600px;\n  margin: 0 auto;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 50%;\n}\n\n.central-wrapper-engg {\n  position: absolute;\n  width: 180px;\n  height: 180px;\n  border-radius: 50%;\n  border: 3px dotted #ddd;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.central-image-engg {\n  position: absolute;\n  width: 150px;\n  height: 150px;\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.central-image-engg img {\n  width: 100%;\n  height: 100%;\n  border-radius: 50%;\n  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.3);\n}\n\n.circular-item-engg {\n  position: absolute;\n  display: flex;\n  align-items: center;\n  transform-origin: center;\n}\n.line-engg {\n  position: absolute;\n  width: 120px !important;\n  height: 0.15px !important;\n  background: transparent;\n  border-top: 2px dashed #000 !important;\n  transform-origin: left;\n}\n\n.line-1-engg {\n  width: 50% !important;\n  transform: rotate(-50deg);\n  top: 290% !important;\n  right: 56% !important;\n}\n.line-2-engg {\n  top: 50%;\n  left: -123% !important;\n  width: 122% !important;\n  transform: rotate(0deg);\n}\n.line-3-engg {\n  top: 0%;\n  left: 20%;\n  width: 47% !important;\n  transform: rotate(230deg);\n}\n.line-4-engg {\n  top: 50%;\n  left: 188%;\n  width: 87% !important;\n  transform: rotate(180deg);\n}\n.line-5-engg {\n  top: 315%;\n  left: 128%;\n  width: 66% !important;\n  transform: rotate(223deg);\n}\n.line-6-engg {\n  top: -10%;\n  left: 78%;\n  width: 47% !important;\n  transform: rotate(320deg);\n}\n.circular-button-engg {\n  display: flex;\n  align-items: center;\n  background: white;\n  border: 2px solid black;\n  border-radius: 50px;\n  padding: 5px 10px;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n  gap: 10px;\n}\n.circular-button-engg img {\n  width: 40px;\n  height: 40px;\n  transition: transform 0.1s ease;\n}\n\n.circular-button-engg:hover {\n  transform: scale(1.2);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n}\n\n.circular-button-engg:hover img {\n  transform: scale(1.1);\n}\n\n.circular-button-engg.reverse:hover {\n  transform: scale(1.1);\n}\n.circular-button-engg.reverse {\n  flex-direction: row;\n}\n\n.circular-button-engg.reverse img {\n  margin-right: 0;\n  margin-left: 5px;\n}\n\n.circular-button-engg:hover {\n  background-color: #abe46c;\n}\n\n.circular-button-engg.active-button-engg {\n  background-color: #abe46c;\n  color: black;\n  cursor: default;\n}\n\n.circular-item-engg img {\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n}\n\n.circular-item-engg p {\n  margin: 0;\n  font-size: 14px;\n  font-weight: bold;\n}\n\n.page-section-engg {\n  margin-top: 20px;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  background-color: #f9f9f9;\n  margin-bottom: -50px;\n  margin-top: -80px;\n}\n\n.page-section-engg h2 {\n  font-size: 1.8em;\n  margin-bottom: 20px;\n}\n\n.page-section-engg p {\n  font-size: 1.2em;\n  color: #555;\n}\n\n@media screen and (max-width: 768px) {\n  .circular-container-engg {\n    width: 400px;\n    height: 400px;\n    padding-bottom: 30px;\n  }\n\n  .central-image-engg img {\n    width: 50%;\n    height: 50%;\n    border-radius: 50%;\n    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.3);\n  }\n\n  .central-wrapper-engg {\n    position: absolute;\n    width: 90px;\n    height: 90px;\n    border-radius: 50%;\n    border: 3px dotted #ddd;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n\n  .circular-item-engg {\n    transform-origin: center;\n  }\n\n  .circular-button-engg {\n    padding: 4px 4px;\n    gap: 3px;\n  }\n\n  .circular-item-engg p {\n    font-size: 10px;\n  }\n\n  .line-engg {\n    width: 60px !important;\n    height: 0.1px !important;\n    border-top: 1px dashed #000 !important;\n  }\n\n  .line-1-engg {\n    width: 45% !important;\n    transform: rotate(-55deg);\n    top: 230% !important;\n    left: 15% !important;\n  }\n  .line-2-engg {\n    top: 40%;\n    left: -32% !important;\n    width: 35% !important;\n    transform: rotate(0deg);\n  }\n  .line-3-engg {\n    top: -5%;\n    left: 40%;\n    width: 32% !important;\n    transform: rotate(230deg);\n  }\n  .line-4-engg {\n    top: 43%;\n    left: 125%;\n    width: 25% !important;\n    transform: rotate(180deg);\n  }\n  .line-5-engg {\n    top: 230%;\n    left: 98%;\n    width: 49% !important;\n    transform: rotate(230deg);\n  }\n  .line-6-engg {\n    top: -7%;\n    left: 70%;\n    width: 28% !important;\n    transform: rotate(308deg);\n  }\n  .circular-button-engg:hover img {\n    transform: scale(0.9);\n  }\n\n  .circular-button-engg.reverse:hover {\n    transform: scale(1.1);\n  }\n  .circular-button-engg:hover {\n    transform: scale(1.1);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
